import http from './http';

const getComments = (value, page, author) => {
  const q = value ? `&query=${encodeURIComponent(value)}` : '';
  const a = author ? `${encodeURIComponent(author)}` : '';
  return http.get(`/comment?author=${a}&page_size=12&page_nbr=${page}&sort_field=created_at&sort_type=desc${q}`);
};

export default { getComments };
export { getComments };
